import { useState, useEffect, useContext } from "react";
import { PortalContext } from "../../../context/portal-context";
import CompWLIndex from "../PageWorkplaceLearningReports/CompWLIndex";

type TPageDashboardStudentProps = {
  user: any;
};

export default function PageDashboardStudent(
  props: TPageDashboardStudentProps
) {
  const { setCustomText } = useContext(PortalContext);
  useEffect(() => {
    setCustomText(null);
  }, []);

  return <div className="row" data-comp="PageDashboardStudent">
    <CompWLIndex />
  </div>;
}
